export default __webpack_public_path__ + "static/helehrcase2-0398fee5b680502a9c0a1de619c80edb.png";